"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _filterInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _Object$keys2 = require("@babel/runtime-corejs3/core-js-stable/object/keys");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _Checkbox = _interopRequireDefault(require("../Forms/Checkbox"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _constants = require("../utils/constants");

var _FormInput = _interopRequireDefault(require("../Forms/FormInput"));

var _FormMessage = _interopRequireDefault(require("../Forms/_FormMessage"));

var _InputGroup = _interopRequireDefault(require("../InputGroup/InputGroup"));

var _keycode = _interopRequireDefault(require("keycode"));

var _List = _interopRequireDefault(require("../List/List"));

var _Popover = _interopRequireDefault(require("../Popover/Popover"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRequiredIf = _interopRequireDefault(require("react-required-if"));

var _shortId = _interopRequireDefault(require("../utils/shortId"));

var _Token = _interopRequireDefault(require("../Token/Token"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _react = _interopRequireWildcard(require("react"));

var _checkbox = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/checkbox.css") : void 0);

var _inputGroup = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/input-group.css") : void 0);

var _list = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/list.css") : void 0);

var _tokenizer = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/tokenizer.css") : void 0);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = _Object$keys2(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty2(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context6; _forEachInstanceProperty(_context6 = ownKeys(Object(source), true)).call(_context6, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context7; _forEachInstanceProperty(_context7 = ownKeys(Object(source))).call(_context7, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _checkbox.default), _inputGroup.default), _list.default), _tokenizer.default));
var isUsingCssModules = _tokenizer.default && (0, _keys.default)(_tokenizer.default).length > 0;
/** A **MultiInput** allows users to enter multiple values which are displayed as a tokens. It provides an editable input field for filtering the list,
 * and a dropdown menu with a list of the available options.
 * If the entries are not validated by the application, users can also enter custom values. */

var MultiInput = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(MultiInput, _Component);

  var _super = _createSuper(MultiInput);

  function MultiInput(props) {
    var _this;

    (0, _classCallCheck2.default)(this, MultiInput);
    _this = _super.call(this, props);

    _this.createTagList = function (data) {
      var cssNamespace = _this.props.cssNamespace;
      return (0, _map.default)(data).call(data, function (item, index) {
        return /*#__PURE__*/_react.default.createElement(_List.default.Item, {
          key: index
        }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
          checked: _this.isChecked(item),
          className: classnames("".concat(cssNamespace, "-list__input")),
          compact: _this.props.compact,
          id: index + "_".concat(_this.multiInputId),
          labelClassName: classnames("".concat(cssNamespace, "-list__label")),
          onChange: function onChange() {
            return _this.updateSelectedTags(item);
          },
          value: item
        }, /*#__PURE__*/_react.default.createElement(_List.default.Text, {
          className: classnames("".concat(cssNamespace, "-checkbox__text"))
        }, item)));
      });
    };

    _this.handleTagKeyDown = function (event, tag) {
      if ((0, _keycode.default)(event) === 'backspace' || (0, _keycode.default)(event) === 'delete') {
        _this.removeTag(tag);
      }
    };

    _this.createTags = function () {
      var _context;

      var cssNamespace = _this.props.cssNamespace;
      return (0, _map.default)(_context = _this.state.tags).call(_context, function (tag, index) {
        if (index < 3) {
          return /*#__PURE__*/_react.default.createElement(_Token.default, {
            className: isUsingCssModules && classnames("".concat(cssNamespace, "-token")),
            key: index,
            onClick: function onClick() {
              return _this.removeTag(tag);
            },
            onKeyDown: function onKeyDown(event) {
              return _this.handleTagKeyDown(event, tag);
            }
          }, tag);
        } else if (index >= _this.state.tags.length - 1) {
          return /*#__PURE__*/_react.default.createElement("span", {
            className: classnames("".concat(cssNamespace, "-tokenizer__indicator"))
          }, _this.state.tags.length - 3, " more");
        } else {
          return null;
        }
      });
    };

    _this.updateSelectedTags = function (tag) {
      var _context2;

      if ((0, _indexOf.default)(_context2 = _this.state.tags).call(_context2, tag) === -1) {
        _this.setState(function (prevState) {
          var tags = prevState.tags;
          tags.push(tag);
          return {
            tags: tags
          };
        }, function () {
          return _this.props.onTagsUpdate(_this.state.tags);
        });
      } else {
        _this.setState(function (prevState) {
          var _context3;

          var tags = (0, _filter.default)(_context3 = prevState.tags).call(_context3, function (item) {
            return item.toLowerCase() !== tag.toLowerCase();
          });
          return {
            tags: tags
          };
        }, function () {
          return _this.props.onTagsUpdate(_this.state.tags);
        });
      }
    };

    _this.isChecked = function (tag) {
      var _context4;

      if ((0, _indexOf.default)(_context4 = _this.state.tags).call(_context4, tag) === -1) {
        return false;
      } else {
        return true;
      }
    };

    _this.removeTag = function (tag) {
      _this.setState(function (prevState) {
        var _context5;

        var tags = (0, _filter.default)(_context5 = prevState.tags).call(_context5, function (item) {
          return item.toLowerCase() !== tag.toLowerCase();
        });
        return {
          tags: tags
        };
      }, function () {
        return _this.props.onTagsUpdate(_this.state.tags);
      });
    };

    _this.showHideTagList = function () {
      _this.setState(function (prevState) {
        return {
          bShowList: !prevState.bShowList
        };
      });
    };

    _this.handleClickOutside = function () {
      _this.setState({
        bShowList: false
      });
    };

    _this.state = {
      bShowList: false,
      tags: []
    };
    _this.multiInputId = _shortId.default.generate();
    return _this;
  } // create tags to display in dropdown list


  (0, _createClass2.default)(MultiInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          popoverProps = _this$props.popoverProps,
          buttonLabel = _this$props.buttonLabel,
          buttonProps = _this$props.buttonProps,
          compact = _this$props.compact,
          className = _this$props.className,
          cssNamespace = _this$props.cssNamespace,
          disabled = _this$props.disabled,
          data = _this$props.data,
          listProps = _this$props.listProps,
          inputProps = _this$props.inputProps,
          onTagsUpdate = _this$props.onTagsUpdate,
          placeholder = _this$props.placeholder,
          tagProps = _this$props.tagProps,
          validationOverlayProps = _this$props.validationOverlayProps,
          validationState = _this$props.validationState,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["popoverProps", "buttonLabel", "buttonProps", "compact", "className", "cssNamespace", "disabled", "data", "listProps", "inputProps", "onTagsUpdate", "placeholder", "tagProps", "validationOverlayProps", "validationState"]);
      var tokenizerClassName = classnames("".concat(cssNamespace, "-tokenizer"), (0, _defineProperty2.default)({}, "".concat(cssNamespace, "-tokenizer--compact"), compact));
      var listClassName = classnames("".concat(cssNamespace, "-list--dropdown"), "".concat(cssNamespace, "-list--multi-input"), (0, _defineProperty2.default)({}, "".concat(cssNamespace, "-list--has-message"), validationState === null || validationState === void 0 ? void 0 : validationState.state));
      var inputGroupClasses = classnames("".concat(cssNamespace, "-input-group--control"), (0, _defineProperty2.default)({
        'is-disabled': disabled
      }, "is-".concat(validationState === null || validationState === void 0 ? void 0 : validationState.state), validationState === null || validationState === void 0 ? void 0 : validationState.state));

      var popoverBody = /*#__PURE__*/_react.default.createElement(_List.default, (0, _extends2.default)({
        className: listClassName,
        compact: compact
      }, listProps), this.createTagList(data));

      var inputGroup = /*#__PURE__*/_react.default.createElement(_InputGroup.default, (0, _extends2.default)({}, rest, {
        "aria-expanded": this.state.bShowList,
        "aria-haspopup": "true",
        className: inputGroupClasses,
        compact: compact,
        disabled: disabled,
        onClick: this.showHideTagList,
        validationOverlayProps: validationOverlayProps,
        validationState: this.state.bShowList ? null : validationState
      }), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, tagProps, {
        className: tokenizerClassName
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-tokenizer__inner"))
      }, this.state.tags.length > 0 && this.createTags(), /*#__PURE__*/_react.default.createElement(_FormInput.default, (0, _extends2.default)({}, inputProps, {
        className: classnames("".concat(cssNamespace, "-input-group__input"), "".concat(cssNamespace, "-tokenizer__input"), (0, _defineProperty2.default)({}, "".concat(cssNamespace, "-input"), isUsingCssModules)),
        compact: compact,
        disabled: disabled,
        placeholder: placeholder
      })))), /*#__PURE__*/_react.default.createElement(_InputGroup.default.Addon, {
        isButton: true
      }, /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({
        "aria-label": buttonLabel
      }, buttonProps, {
        disabled: disabled,
        glyph: "value-help",
        option: "transparent"
      }))));

      return /*#__PURE__*/_react.default.createElement(_Popover.default, (0, _extends2.default)({}, popoverProps, {
        body: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, validationState && /*#__PURE__*/_react.default.createElement(_FormMessage.default, (0, _extends2.default)({}, validationOverlayProps === null || validationOverlayProps === void 0 ? void 0 : validationOverlayProps.formMessageProps, {
          forPopoverList: true,
          type: validationState.state
        }), validationState.text), popoverBody),
        control: inputGroup,
        disableKeyPressHandler: true,
        disabled: disabled,
        noArrow: true,
        onClickOutside: this.handleClickOutside,
        useArrowKeyNavigation: true,
        widthSizingType: "matchTarget"
      }));
    }
  }]);
  return MultiInput;
}(_react.Component);

MultiInput.displayName = 'MultiInput';
process.env.NODE_ENV !== "production" ? MultiInput.propTypes = {
  /** Collection of items to display in the list */
  data: _propTypes.default.array.isRequired,

  /** Localized string label for dropdown button's aria-label. This is required if `buttonProps` doesn't have a valid `aria-label`. */
  buttonLabel: (0, _reactRequiredIf.default)(_propTypes.default.string, function (props) {
    var _props$buttonProps$ar;

    return !(props !== null && props !== void 0 && props.buttonProps) || !((_props$buttonProps$ar = props.buttonProps['aria-label']) !== null && _props$buttonProps$ar !== void 0 && (0, _trim.default)(_props$buttonProps$ar).call(_props$buttonProps$ar));
  }),

  /** Additional props to be spread to the `<button>` element */
  buttonProps: _propTypes.default.object,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Set to **true** to enable compact mode */
  compact: _propTypes.default.bool,

  /** Set to **true** to mark component as disabled and make it non-interactive */
  disabled: _propTypes.default.bool,

  /** Additional props to be spread to the `<input>` element */
  inputProps: _propTypes.default.object,

  /** Additional props to be spread to the `<ul>` element */
  listProps: _propTypes.default.object,

  /** Localized placeholder text of the input */
  placeholder: _propTypes.default.string,

  /** Additional props to be spread to the Popover component */
  popoverProps: _propTypes.default.object,

  /** Additional props to be spread to the tags `<div>` element */
  tagProps: _propTypes.default.object,

  /** Additional props to be spread to the ValidationOverlay */
  validationOverlayProps: _propTypes.default.shape({
    /** Additional classes to apply to validation popover's outermost `<div>` element  */
    className: _propTypes.default.string,

    /** Additional props to be spread to the ValdiationOverlay's FormMessage component */
    formMessageProps: _propTypes.default.object,

    /** Additional classes to apply to validation popover's popper child `<div>` wrapping the provided children  */
    innerRefClassName: _propTypes.default.string,

    /** Additional classes to apply to validation popover's popper `<div>` element  */
    popperClassName: _propTypes.default.string,

    /** CSS class(es) to add to the ValidationOverlay's reference `<div>` element */
    referenceClassName: _propTypes.default.string,

    /** Additional props to be spread to the popover's outermost `<div>` element */
    wrapperProps: _propTypes.default.object
  }),

  /** An object identifying a validation message.  The object will include properties for `state` and `text`; _e.g._, \`{ state: \'warning\', text: \'This is your last warning\' }\` */
  validationState: _propTypes.default.shape({
    /** State of validation: 'error', 'warning', 'information', 'success' */
    state: _propTypes.default.oneOf(_constants.FORM_MESSAGE_TYPES),

    /** Text of the validation message */
    text: _propTypes.default.string
  }),

  /**
   * Callback function; triggered when a tag is added or removed.
   *
   * @param {string[]} selectedTags array of selected tags as strings
   * @returns {void}
   * */
  onTagsUpdate: _propTypes.default.func
} : void 0;
MultiInput.defaultProps = {
  onTagsUpdate: function onTagsUpdate() {}
};

var _default = (0, _withStyles.default)(MultiInput);

exports.default = _default;